import { render, staticRenderFns } from "./common-dishe.vue?vue&type=template&id=7d4b7b32&"
import script from "./common-dishe.vue?vue&type=script&lang=js&"
export * from "./common-dishe.vue?vue&type=script&lang=js&"
import style0 from "./common-dishe.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports